import { render, staticRenderFns } from "./InactiveAccountTab.vue?vue&type=template&id=f3489958"
import script from "./InactiveAccountTab.vue?vue&type=script&lang=js"
export * from "./InactiveAccountTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports